import React, { PropsWithChildren } from 'react';

import { InfoIcon, WarningDanger } from '../icons';

import styles from './note.module.scss';
type NoteProps = {
  variant?: 'info' | 'danger';
  isFullWidth?: boolean;
};

export const Note: React.FC<PropsWithChildren<NoteProps>> = ({
  children,
  variant = 'info',
  isFullWidth,
}) => (
  <div
    className={`${styles['container']} note-container`}
    data-variant={variant}
    data-full={isFullWidth}
  >
    {variant === 'danger' ? <WarningDanger /> : <InfoIcon />}

    <div className={styles['text']}>{children}</div>
  </div>
);
